// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation-module__navigation--2znoA"};